module.exports = __webpack_public_path__ + "img/connections.4d0f2356.svg";